import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class Asrama extends BaseEntity {

	@serialize
	@deserialize
	public kode: string = "";

	@serialize
	@deserialize
	public nama: string = "";

	@serialize
	@deserialize
	public jenis_kelamin: string = "";

	@serialize
	@deserialize
	public nama_rekening: string = "";

	@serialize
	@deserialize
	public nomor_rekening: string = "";

	@serialize
	@deserialize
	public pimpinan: string = "";

	@serialize
	@deserialize
	public pondok: string = "";

	public file: any = null;

	public fileFeedback() {
		return this.defaultPropertyFeedback('file', Boolean(this.file));
	}

	public table() {
		const {
			nama:nama_asrama, pimpinan, pondok
		} = this;
		return {
			nama_asrama, pimpinan, pondok
		};
	}

	public static columnName(): Array<TableColumn> {
		const absensi = new Asrama().table();
		let keys = Object.keys(absensi);

		return keys.map((field: any) => {
			const tableColumn = new TableColumn();
			tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

			return tableColumn;
		});
	}

}
